export default __webpack_public_path__ + "static/media/minus.bce9cd64.svg";